"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var global_1 = require("../global");
var log_1 = require("../log");
var instantiate_1 = require("./instantiate");
var logger = log_1.getLogger("template/xml");
var BIND_REGEX = RegExp(/@{ *(.+?) *}/);
var domParser = new DOMParser();
function parse(template) {
    var xml = domParser.parseFromString(template, "text/xml").children[0];
    if (xml.childElementCount !== 1) {
        logger.error("The template must be enclosed in one element.");
    }
    var rootElement = xml.children[0];
    var height = parseFloat(xml.getAttribute("svgHeight"));
    if (height > 0) {
        global_1.default.currentVisualizer.size.height = height;
    }
    return parseElement(rootElement);
}
exports.parse = parse;
function parseElement(element) {
    var splitted = element.tagName.split(".");
    var tagName = splitted[0];
    var isGroup = false;
    var modifiers = splitted.slice(1);
    // compatibility for legacy syntax
    if (_.startsWith(tagName, "group-")) {
        isGroup = true;
        tagName = tagName.substr(6);
    }
    // options
    var obj = {
        _type: tagName,
        _isGroup: isGroup,
    };
    for (var _i = 0, modifiers_1 = modifiers; _i < modifiers_1.length; _i++) {
        var modifier = modifiers_1[_i];
        switch (modifier) {
            case "g":
                isGroup = true;
                break;
            case "group":
                isGroup = true;
                break;
            case "fs":
                obj._width = "100%";
                obj._height = "100%";
                break;
        }
    }
    var elementName = instantiate_1.elementNames[tagName];
    if (!elementName) {
        elementName = global_1.default.currentVisualizer.exElementList[tagName];
    }
    if (typeof elementName === "undefined") {
        logger.error("Unknown element type: " + element.tagName);
        return;
    }
    for (var _a = 0, _b = Array.from(element.attributes); _a < _b.length; _a++) {
        var attr = _b[_a];
        var name_1 = attr.nodeName;
        var value = attr.nodeValue;
        var prop = void 0;
        if (name_1[0] === "_" || _.startsWith(name_1, "bv:")) {
            var rawName = name_1[0] === "_" ? name_1.substr(1) : name_1.substr(3);
            // dot separated?
            var splitted_1 = rawName.split(".");
            if (splitted_1.length === 1) {
                if (eventMap[rawName]) {
                    name_1 = eventMap[rawName];
                }
                else {
                    name_1 = "_" + rawName;
                }
            }
            else {
                name_1 = "_" + splitted_1[0];
                prop = splitted_1[1];
            }
        }
        var resultValue = void 0;
        if (_.includes(PARSE_ATTR, name_1)) {
            resultValue = parseAttributeValue(name_1, value);
        }
        else {
            if (value[0] === "@") {
                resultValue = parseBindings(name_1, value);
            }
            else {
                resultValue = elementName.parseAttributeValue(name_1, value);
            }
        }
        if (typeof prop === "string") {
            if (typeof obj[name_1] === "undefined") {
                obj[name_1] = {};
            }
            obj[name_1][prop] = resultValue;
        }
        else {
            obj[name_1] = resultValue;
        }
    }
    // children
    if (element.childElementCount > 0) {
        obj._children = [];
        for (var i = 0; i < element.childElementCount; i++) {
            var child = element.children[i];
            obj._children.push(parseElement(child));
        }
    }
    else if (element.textContent) {
        var attrForContent = elementName.attributeForTagContent();
        if (!(typeof attrForContent === "string" && attrForContent.length > 0)) {
            logger.warn("Got tag content when the element " + element.tagName + " doesn't require one.");
        }
        else {
            if (element.textContent[0] === "@") {
                obj[attrForContent] = parseBindings(attrForContent, element.textContent);
            }
            else {
                obj[attrForContent] = elementName.parseAttributeValue(attrForContent, element.textContent);
            }
        }
    }
    return obj;
}
var PARSE_ATTR = ["_data", "_datum", "_outlet"];
var eventMap = {
    mouseEnter: "_$mouseEnter",
    mouseLeave: "_$mouseLeave",
    mouseMove: "_$mouseMove",
    click: "_$mouseClick",
    mouseDown: "_$mouseDown",
    mouseUp: "_$mouseUp",
    brushStart: "_$brushStart",
    brushUpdate: "_$brushUpdate",
    brushEnd: "_$brushEnd",
};
function parseAttributeValue(attr, value) {
    switch (attr) {
        case "_data":
        case "_datum":
            value = _.trim(value);
            if (value[0] === "@") {
                if (value[1] === "{") {
                    var match = value.match(BIND_REGEX);
                    if (match) {
                        var func = new Function("d", "i", "g", "return " + match[1]);
                        return func;
                    }
                    else {
                        logger.error("Invalid syntax for " + attr + ":\n  " + value);
                    }
                }
                else {
                    return { __dataKey__: value.substr(1) };
                }
            }
            else {
                // check is raw data
                try {
                    var parsed = JSON.parse(value);
                    return parsed;
                }
                catch (_a) {
                    logger.error("Invalid syntax for " + attr + ":\n  " + value);
                }
            }
        case "_outlet":
            return value;
    }
    return null;
}
function parseBindings(attr, value) {
    if (value[0] !== "@") {
        return;
    }
    // check is data binding
    if (value[1] === "{") {
        // using literial
        var match = value.match(BIND_REGEX);
        if (match) {
            var func = new Function("d", "i", "g", "return " + match[1]);
            return func;
        }
        else {
            logger.error("Invalid syntax for " + attr + ":\n  " + value);
        }
        return null;
    }
    else {
        // using transformer
        if (attr[1] === "$" || attr === "_on") {
            // is event handler
            var handlerName = value.substr(1);
            return global_1.default.currentVisualizer.eventHandlers[handlerName];
        }
        else {
            var transformerName = value.substr(1);
            var t = global_1.default.currentVisualizer.transformers[transformerName];
            if (typeof t === "undefined") {
                return { __objectKey__: transformerName };
            }
            return t;
        }
    }
}
var parser = { parse: parse };
exports.default = parser;
//# sourceMappingURL=xml.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/template/xml.js
// module id = 1009
// module chunks = 0 1